module.exports = __WEBPACK_EXTERNAL_MODULE_249__;


//////////////////
// WEBPACK FOOTER
// external "gemini/dashboard/glass/BaseBoardView"
// module id = 249
// module chunks = 0